import * as React from 'react';
import styles from './index.less';
import { Carousel } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import fMessage from '@/components/fMessage';

interface Banner1Props {}

function Banner1({}: Banner1Props) {
  const refCarousel = React.useRef<any>(null);
  const [$currentSlide, set$currentSlide, get$currentSlide] = FUtil.Hook.useGetState(0);
  const [$dataSource, set$dataSource, get$dataSource] = FUtil.Hook.useGetState<
    {
      id: string;
      cover: string;
      title: string;
      href: string;
    }[]
  >([]);

  AHooks.useMount(async () => {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        dataList: {
          _id: string;
          title: string;
          cover: string;
          link: string;
          linkActivityId: string;
        }[];
      };
    } = await FServiceAPI.Activity.adsList({
      limit: 100,
      place: 5,
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }
    // console.log(data, 'data sdifjsdl;kfjlsdkjlk');
    const dataList = data?.dataList ?? [];
    set$dataSource(
      dataList.map((d) => {
        return {
          id: d._id,
          title: d.title,
          cover: d.cover,
          href: d.linkActivityId
            ? FUtil.Format.completeUrlByDomain('www') +
              FUtil.LinkTo.activity({ activityID: d.linkActivityId })
            : d.link,
        };
      }),
    );
  });

  if ($dataSource.length === 0) {
    return null;
  }

  return (
    <div className={styles.styles}>
      <Carousel
        ref={refCarousel}
        autoplay={true}
        dotPosition={'bottom'}
        dots={false}
        afterChange={(currentSlide) => {
          // console.log(currentSlide, 'FFFFFFFFFFFFFFFFFFFF##############');
          set$currentSlide(currentSlide);
        }}
      >
        {$dataSource.map((d) => {
          return (
            <a key={d.id} className={styles.CarouselItem} target={'_blank'} href={d.href}>
              <img src={d.cover} alt={d.title} />
            </a>
          );
        })}
        {/*<a className={styles.CarouselItem}>*/}
        {/*  /!*<img src={img_banner1} alt={''} />*!/*/}
        {/*</a>*/}
        {/*<a className={styles.CarouselItem}>*/}
        {/*  /!*<img src={img_banner1} alt={''} />*!/*/}
        {/*</a>*/}
      </Carousel>

      <div
        className={[styles.pageTurning, styles.left].join(' ')}
        onClick={() => {
          refCarousel.current?.prev();
        }}
      >
        <FComponentsLib.FIcons.FLeft style={{ fontSize: 26, color: '#fff' }} />
      </div>
      <div
        className={[styles.pageTurning, styles.right].join(' ')}
        onClick={() => {
          refCarousel.current?.next();
        }}
      >
        <FComponentsLib.FIcons.FRight style={{ fontSize: 26, color: '#fff' }} />
      </div>

      <div className={styles.dots}>
        {$dataSource.map((d, di) => {
          return (
            <label
              key={d.id}
              className={[styles.dot, $currentSlide === di ? styles.active : ''].join(' ')}
              onClick={() => {
                refCarousel.current?.goTo(di);
              }}
            />
          );
        })}

        {/*<label className={styles.dot} />*/}
        {/*<label className={styles.dot} />*/}
      </div>
    </div>
  );
}

export default Banner1;
